import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { actionKey } from './constants';
import { uploadFile, uploadFiles, uploadProgress, uploadSuccess, uploadFailure, uploadFileImmediately, cancelFileUpload, removeErroredUpload, clearCompletedUploads, uploadDocument, uploadDocumentProgress, uploadDocumentSuccess, uploadDocumentFailure, cancelDocumentUpload } from './actions';
import { handleActions } from 'redux-actions';
const defaultState = {
    fileUploads: [],
    fileUploadsWaiting: [],
    fileUploadsCompleted: [],
    documentUploads: {
        narf: undefined,
        sprf: undefined
    }
};
const actionHandlers = handleActions({
    [uploadFile.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            fileUploadsWaiting: [
                ...state.fileUploadsWaiting,
                _object_spread({}, payload)
            ]
        }),
    [uploadFiles.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            fileUploadsWaiting: [
                ...state.fileUploadsWaiting,
                ...payload.files
            ]
        }),
    [uploadFileImmediately.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: [
                ...state.fileUploads,
                _object_spread({}, payload)
            ],
            fileUploadsWaiting: state.fileUploadsWaiting.filter((f)=>f.fileId !== payload.fileId)
        }),
    [uploadFailure.toString()]: (state, { payload: { fileId, error } })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: [
                ...state.fileUploads
            ].map((item)=>item.fileId === fileId ? _object_spread_props(_object_spread({}, item), {
                    error
                }) : item)
        }),
    [uploadProgress.toString()]: (state, { payload: { fileId, progress } })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: [
                ...state.fileUploads
            ].map((item)=>item.fileId === fileId ? _object_spread_props(_object_spread({}, item), {
                    progress
                }) : item)
        }),
    [uploadSuccess.toString()]: (state, { payload })=>{
        const fileUploadInfo = state.fileUploads.find((item)=>payload.fileId === item.fileId);
        if (!fileUploadInfo) {
            return state;
        }
        return _object_spread_props(_object_spread({}, state), {
            fileUploads: state.fileUploads.filter((item)=>payload.fileId !== item.fileId),
            fileUploadsCompleted: [
                _object_spread_props(_object_spread({}, fileUploadInfo), {
                    deviationId: payload.deviationId
                }),
                ...state.fileUploadsCompleted
            ]
        });
    },
    [removeErroredUpload.toString()]: (state, { payload: { fileId } })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: state.fileUploads.filter((item)=>!(item.fileId === fileId && item.error))
        }),
    [cancelFileUpload.toString()]: (state, { payload: { fileId } })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: state.fileUploads.filter((item)=>item.fileId !== fileId),
            fileUploadsWaiting: state.fileUploadsWaiting.filter((item)=>item.fileId !== fileId)
        }),
    [clearCompletedUploads.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            fileUploadsCompleted: []
        }),
    [uploadDocument.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            documentUploads: _object_spread_props(_object_spread({}, state.documentUploads), {
                [payload.documentType]: payload
            })
        }),
    [uploadDocumentProgress.toString()]: (state, { payload: { documentType, progress } })=>_object_spread_props(_object_spread({}, state), {
            documentUploads: _object_spread_props(_object_spread({}, state.documentUploads), {
                [documentType]: _object_spread_props(_object_spread({}, state.documentUploads[documentType]), {
                    progress
                })
            })
        }),
    [uploadDocumentSuccess.toString()]: (state, { payload: { documentType, documentUrl } })=>{
        return _object_spread_props(_object_spread({}, state), {
            documentUploads: _object_spread_props(_object_spread({}, state.documentUploads), {
                [documentType]: _object_spread_props(_object_spread({}, state.documentUploads[documentType]), {
                    documentUrl
                })
            })
        });
    },
    [uploadDocumentFailure.toString()]: (state, { payload: { documentType, error } })=>_object_spread_props(_object_spread({}, state), {
            documentUploads: _object_spread_props(_object_spread({}, state.documentUploads), {
                [documentType]: _object_spread_props(_object_spread({}, state.documentUploads[documentType]), {
                    error
                })
            })
        }),
    [cancelDocumentUpload.toString()]: (state, { payload: { documentType } })=>_object_spread_props(_object_spread({}, state), {
            documentUploads: _object_spread_props(_object_spread({}, state.documentUploads), {
                [documentType]: undefined
            })
        })
}, defaultState);
const reducers = {
    [actionKey]: actionHandlers
};
export default reducers;

//# sourceMappingURL=reducers.js.map